import Odometer from 'odometer';
import { Controller, Scene } from 'scrollmagic';
import 'nodelist-foreach-polyfill';
import 'odometer/themes/odometer-theme-default.css';

import './counters.scss';

document.addEventListener('DOMContentLoaded', () => {
  const controller = new Controller();
  document.querySelectorAll('[data-counter]').forEach((wrapper, index) => {
    const count = wrapper.querySelector('.counters__data');
    const ht = count.innerHTML;
    let number;
    try {
      number = parseFloat(ht);
    } catch (e) {
      number = null;
    }
    if (number !== null) {
      const odometer = new Odometer({
        el: count,
        value: 0,
      });
      const scene = new Scene({
        triggerElement: wrapper,
        triggerHook: 'onEnter',
        reverse: false,
      });
      scene.addTo(controller);
      scene.on('enter', () => setTimeout(() => {
        odometer.update(number);
        wrapper.classList.add('counters_show');
      }, 200 * index));
      const ut = ht.split(number).join('').trim();
      if (ut !== '') {
        const units = wrapper.querySelector('.counters__units');
        units.innerHTML = ut;
      }
    }
  });
});
